// src/contexts/client-options.ts
import { createContext, useContext } from "react";
var ClientOptionsContext = createContext({});
var useClientOptions = () => useContext(ClientOptionsContext);

export {
  ClientOptionsContext,
  useClientOptions
};
//# sourceMappingURL=chunk-4CM6CARW.mjs.map